<template>
  <section class="hero">
      <div class="hero__content container">
        <div class="hero__header">
          <h1 class="hero__title">
            Unlock the Power of Data!
          </h1>
          <div class="hero__division">
            <div class="hero__video">
              <youtube-player video-id="2DGrok5hufU" autoplay="true" />
            </div>
            <div class="hero__form">
              <Form />
            </div>
          </div>

          <h1 class="hero__title">
            Discover the power of Sequire
          </h1>
          <div class="hero__cards">
            <div class="hero__cards--item">
              <img src="../assets/hero/real-time.svg" alt="Real Time Icon">
              <p>Monitor and Interpret your stock performance data in real time</p>
            </div>
            <div class="hero__cards--item">
              <img src="../assets/hero/relationship.svg" alt="Relations Icon">
              <p>Streamline communication with your investors and stakeholders</p>
            </div>
            <div class="hero__cards--item">
              <img src="../assets/hero/compliance.svg" alt="Compliance Icon">
              <p>Manage your company employee options and previous financing deals</p>
            </div>
          </div>
          <h2 class="hero__description">
            And much more!
          </h2>
          <div class="hero__join">  
            <a href="https://platform.mysequire.com/signup" class="button" target="_blank">
              Join NOW
            </a>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import YoutubePlayer from './YoutubePlayer.vue';
  import Form from './form.vue';

  export default {
    name: 'Hero',
    components: {
      YoutubePlayer,
      Form
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/hero.scss";
  </style>
  